<!--
 * @Descripttion: 地网2.0个人中心功能引导
 * @Author: chenjinsheng
 * @Date: 2021-10-14 11:13:44
 * @LastEditors: chenjinsheng
 * @LastEditTime: 2021-11-12 09:13:02
-->
<template>
    <div class="guidance-container">
        <div class="bg1">
            <img src="@/assets/pics/guide/ubg1.png" alt="" />
        </div>
        <div class="bg2">
            <img src="@/assets/pics/guide/ubg2.png" alt="" />
        </div>
        <div class="bg3">
            <img src="@/assets/pics/guide/ubg3.png" alt="" />
        </div>
        <div class="bg4">
            <img src="@/assets/pics/guide/ubg4.png" alt="" />
        </div>
        <div class="bg5">
            <img src="@/assets/pics/guide/ubg5.png" alt="" />
        </div>
        <div class="bg6">
            <img src="@/assets/pics/guide/ubg6.png" alt="" />
        </div>
        <div class="bg7">
            <img src="@/assets/pics/guide/ubg7.png" alt="" />
        </div>
        <div class="bg8">
            <img src="@/assets/pics/guide/ubg8.png" alt="" />
        </div>
    </div>
</template>

<script>
export default {
    name: "UserGuidance",
};
</script>

<style lang="scss" scoped>
.guidance-container {
    height: 100%;
    overflow-y: auto;
    div {
        margin-top: -2px;
    }
}
</style>
